module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_studio@2x-a85bb3208fb20c3f7f4220c19f17ad0a.webp";